export default __webpack_public_path__ + "static/media/Rectangle2.c10a0061.jpg";